<script lang="ts" setup>
import BaseTag from './BaseTag.vue';

defineProps<{
  name?: string;
}>();
</script>

<template>
  <BaseTag
    bg-sky-800
    :class="{ 'cursor-pointer': !!$attrs.onClick }"
    v-bind="$attrs"
  >
    {{ name }}
    <slot />
  </BaseTag>
</template>
